// eslint-disable-next-line func-style, @typescript-eslint/no-explicit-any
export function invariant(label: string, value: any): asserts value {
  if (!value) {
    throw new Error(label);
  }

  return value;
}
